import { read, write } from "@/lib/storage";

const DEMO_EMAIL = "logika@filsuf.com";
// Prototipe: kata sandi dibandingkan lewat hash SHA-256, tidak disimpan di session.

async function sha256(text) {
  if (window.crypto && window.crypto.subtle) {
    const buf = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(`lf::${text}`));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
  }
  return `plain:${text}`;
}

let expectedHash = null;
async function getExpected() {
  if (!expectedHash) expectedHash = await sha256("epictetus");
  return expectedHash;
}

export async function login(email, password) {
  const ok = email.trim().toLowerCase() === DEMO_EMAIL && (await sha256(password)) === (await getExpected());
  if (!ok) return { ok: false, message: "Email atau kata sandi tidak sesuai. Periksa kembali lalu coba lagi." };
  write("session", { email: DEMO_EMAIL, loggedInAt: new Date().toISOString() });
  return { ok: true };
}

export const logout = () => write("session", null);
export const isLoggedIn = () => {
  const s = read("session");
  return !!(s && s.email === DEMO_EMAIL);
};
export { DEMO_EMAIL };
